import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class Toaster {

  private messagesSubject = new BehaviorSubject<{ message: string; type: 'success' | 'info' | 'error' }[]>([]);
  messages$ = this.messagesSubject.asObservable();
  private autoCloseTimer: any = null;

  setError(msg: { message: string; type: 'success' | 'info' | 'error' }) {
    if (this.autoCloseTimer) {
      clearTimeout(this.autoCloseTimer);
    }
    this.messagesSubject.next([msg]);
    this.autoCloseTimer = setTimeout(() => this.clearAll(), 5000);
  }

  removeMessage(index: number) {
    if (this.autoCloseTimer) {
      clearTimeout(this.autoCloseTimer);
      this.autoCloseTimer = null;
    }
    this.messagesSubject.next([]);
  }

  clearAll() {
    this.autoCloseTimer = null;
    this.messagesSubject.next([]);
  }
}
